import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { TablerCategoryIconsAsset } from '@shared/utils/product-category-icon.utils';

@Injectable()
export class CategoryIconRegistryApiService {
  /**
   * El registro es estático y pesado. Se descarga y parsea una sola vez por
   * sesión del feature, aunque se abran varios diálogos de categoría.
   */
  private readonly registry$ = this.http
    .get<TablerCategoryIconsAsset>('assets/tabler-category-icons.json')
    .pipe(shareReplay({ bufferSize: 1, refCount: false }));

  constructor(private readonly http: HttpClient) {}

  load(): Observable<TablerCategoryIconsAsset> {
    return this.registry$;
  }
}
